import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutTemplate, WorkoutTemplateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateWorkoutTemplate(): UseMutationResult<
  AxiosResponse<WorkoutTemplate>,
  AxiosError<ErrorMessage>,
  WorkoutTemplateWrite
> {
  const queryClient = useQueryClient();

  const updateWorkoutTemplate = (payload: WorkoutTemplateWrite): Promise<AxiosResponse<WorkoutTemplate>> => {
    return client.put(`workout-templates/${payload.workoutTemplateId}/`, payload);
  };

  return useMutation(updateWorkoutTemplate, {
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries('workoutTemplates');
      queryClient.invalidateQueries(['workoutTemplate', payload.workoutTemplateId]);
    },
  });
}
